<template>
    <div class="position-box"> 
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('order.ddxq')}}</div>
        </div> 
        <div class="cont-box">
           <vue-better-scroll class="wrapper"
                         ref="scroll"                         
                         :scrollbar="scrollbarObj"
                         :pullDownRefresh="pullDownRefreshObj"
                         :pullUpLoad="pullUpLoadObj"
                         :startY="parseInt(startY)" 
                         :probeType="1"
                         :listenScroll=true
                         @scroll="scroll"                                             
                         @pulling-down="onPullingDown"
                         @pulling-up="onPullingUp">
                <ul class="ul-box">
                    <li class="list" v-for="(item,index) in listData" :key="index">
                        <div class="list-head">
                            <img class="img" :src="item.mm_img_url" alt="">
                            <div class="info-box">
                                <div class="title">{{item.mm_name}}</div>
                                <div class="price-box">
                                    <div class="text1">{{$t('wdkj.jg')}}{{item.mm_money}} USDT</div>
                                    <div class="text2">{{$t('wdkj.wkzts')}}{{item.mm_cycle}} <span v-show="lang == 'zh' || lang == 'ft'">{{$t('wdkj.day')}}</span></div>
                                </div>
                                <div class="sl-box">
                                    <div class="text1">{{$t('wdkj.sl')}}{{item.mm_cp_num}} T</div>
                                    <div class="text2">{{$t('wdkj.rwk')}}{{item.mm_btcm_money}} GDCC</div>
                                </div>
                            </div>
                        </div>                        
                        <div class="list-foot">
                            <div class="item">{{$t('wdkj.kjbh')}}{{item.mm_sn}}</div>
                            <div class="item">{{$t('wdkj.ywkts')}}{{item.producted_day}} <span v-show="lang == 'zh' || lang == 'ft'">{{$t('wdkj.day')}}</span></div>
                            <div class="item">{{$t('wdkj.ywksl')}}<span class="red">{{item.produced_money}} GDCC</span></div>
                            <div class="item">{{$t('wdkj.zyrq')}}{{item.create_time | times(timestamp)}}</div>
                        </div>
                        <div class="status" :class="{active: item.review_status == 1 && item.status == 1}" v-if="item.review_status == 1">{{item.status | statusText}}</div>
                        <div class="status active" v-else-if="item.review_status == 0">{{$t('wdkj.wsh')}}</div>
                        <div class="status active" v-else-if="item.review_status == 2" @click="alert(item.reject_remarks)">{{$t('wdkj.wtg')}} <img class="icon" src="@/assets/error.png" alt=""></div>
                    </li>
                </ul>
                <no-data v-show="hasData"></no-data>  
            </vue-better-scroll> 
            <div class="mask" v-show="isMask"></div>   
             <!-- 审核失败 -->
            <div class="alert-wrap" v-show="isShow">
                <div class="alert-head">
                    {{this.$t('wdkj.sqwtg')}}
                    <img class="icon" src="@/assets/close.png" @click="close" alt="">
                </div>
                <div class="cont">{{cont}}</div>
            </div>  
            <img class="go-top" src="@/assets/top.png" alt="" @click="scrollTo" v-show="isTop">
        </div>               
    </div>
    
</template>

<script>
import noData from '@/components/noData.vue'
import VueBetterScroll from 'vue2-better-scroll'
let that = this;
export default {
    name: 'myOrderDetail',
    data () {
        return {
            lang: 'en',
            listData: [],
            hasData: false,  
            isTop: false, 
            isShow: false,
            isMask: false,
            order_id: '', 
            wkz: '',
            wkwc: '',
            cont: '',
            scrollbarObj: {
                fade: true
            },
             // 这个配置用于做下拉刷新功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启下拉刷新，可以配置顶部下拉的距离（threshold） 来决定刷新时机以及回弹停留的距离（stop）
            pullDownRefreshObj: {
                threshold: 90,
                stop: 40,
                txt: this.$t('tips.sxcg')              
            },
            // 这个配置用于做上拉加载功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启上拉加载，可以配置离底部距离阈值（threshold）来决定开始加载的时机
            pullUpLoadObj: {
                threshold: 0,
                txt: {
                    more: this.$t('tips.jzgd'),
                    noMore: this.$t('tips.mygdsjl')                    
                }
            },
            startY: 0, // 纵轴方向初始化位置            
            scrollToY: 0,
            scrollToTime: 500,
            page: 1,
            limit: 10,
            timestamp: 0, 
        }            
    }, 
    beforeCreate(){
        that = this;
    },
    created(){    
        this.lang = localStorage.getItem('user_lang');
        this.order_id = this.$route.params.id;  
        let uid = this.uid = localStorage.getItem('uid');
        let token = this.token = localStorage.getItem('token');  
        this.timestamp = localStorage.getItem('timestamp') || 0;
    },
    mounted() {   
        this.wkz = this.$t('wdkj.wkz');
        this.wkwc = this.$t('wdkj.wkwc');     
        this.init()
    },     
    methods: {
        init(){  
            let params = {
                order_id: this.order_id,
                uid: this.uid,
                token: this.token,
                limit: this.limit,
                page: this.page
            }          
            this.$ajax.post('/api/Mmorder/mmList',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.code == 200){
                     if(resData.length > 0){        
                        this.hasData = false
                        this.listData = resData;
                        this.$refs.scroll.forceUpdate(true)      
                    }else{
                        this.hasData = true;                       
                    }                       
                }else{
                    this.$toast.bottom(res.data.msg);                    
                }
            }).catch(function(err){
                console.log(err);                
            })      
        },
         /* 下拉刷新的回调 */
        onPullingDown () {
            this.listData = []; 
            this.page = 1;
            this.init(this.curIdx,this.type)
        },
        onPullingUp(){            
            this.page ++;
            let params = {
                order_id: this.order_id,
                uid: this.uid,
                token: this.token,
                limit: this.limit,
                page: this.page
            } 
            this.$ajax.post('/api/Mmorder/mmList',params).then((res) => {                
                let resData = res.data.data;         
                if(res.data.code == 200){                                          
                    if(resData.length > 0){
                        this.listData = this.listData.concat(resData);                        
                        this.$refs.scroll.forceUpdate(true) 
                    }else{
                         this.$refs.scroll.forceUpdate(false) 
                    }                
                }else{
                    this.$toast.bottom(res.data.msg);                  
                }
            }).catch(function(err){
                console.log(err); 
            })   
        }, 
        scroll({x, y}){
            if(Math.abs(y) >= 300){
                this.isTop = true;
            }else{
                this.isTop = false
            }
        },    
        // 滚动到页面顶部
        scrollTo() {            
            this.$refs.scroll.scrollTo(this.scrollToY, this.scrollToTime)
        },
        alert(cont){
            this.isMask = true;
            this.isShow = true;
            this.cont = cont;
        },
        close(){            
            this.isShow = false;
            this.isMask = false;            
        },    
        goBack(){
			this.$router.go(-1);
		}        
    },
    components:{       
        noData,
        VueBetterScroll          
    },
    filters: { 
        statusText: (val) => {            
            if(val == 0){
                return that.wkz
            }else if(val == 1){
                return that.wkwc
            }else{
                return that.wkz
            }           
        },
        times: function(timess){
            var date = new Date((timess - that.timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
            var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
            var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();            
            return Y + M + D + " " + h + m + s;
        }     
    },
}
</script>
<style scoped>
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;  
        color: #cecece;     
        font-size: .24rem;  
        background: url('../assets/element-background.png') no-repeat center center;  
        background-size: cover;
        overflow: hidden;       
    }
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: .8rem;
        font-size: .36rem;
        line-height: .8rem;
        text-align: center;
    }    
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .18rem;
        width: .24rem;
        height: .44rem;     
    } 
    .cont-box{
        position: absolute;
        left: 0;
        top: .8rem;
        bottom: 0;
        width: 100%;
        height: auto;  
        color: #cecece;     
        font-size: .24rem;    
        overflow: hidden;       
    }  
    .ul-box{
        padding: .24rem .14rem;
    }    
    .ul-box .list{  
        position: relative;         
        margin-bottom: .34rem;
        padding: .34rem .1rem .3rem .1rem;   
        background: rgb(4 ,9 ,37,.5);
        border-radius: .1rem;
    }
    .ul-box .list-head{
        display: flex;  
        align-items: center;
        padding: 0 .1rem .26rem .1rem;
        border-bottom: 1px solid #858585;
    }
    .ul-box .list .img{
        width: 1rem;
    }
    .ul-box .list .info-box{
        flex: 1;
        margin-left: .1rem;
        color: #cecece;
        font-size: .24rem;
    }
    .ul-box .list .info-box .title{
        color: #fff;
        font-size: .28rem;
    }
    .ul-box .list .info-box .price-box{
        display: flex;
        justify-content: space-between;
        margin-top: .3rem;
    }
    .ul-box .list .info-box .price-box .text1,.ul-box .list .info-box .sl-box .text1{
        flex: 1;
    }
    .ul-box .list .info-box .price-box .text2,.ul-box .list .info-box .sl-box .text2{
        flex: 1.5;
        margin-left: .1rem;
    }
    .ul-box .list .info-box .sl-box{
        display: flex;
        justify-content: space-between;
        margin-top: .18rem;
    }       
    .list-foot{
        padding: .3rem .16rem 0;
        color: #cecece;
        font-size: .24rem;
    }
    .list-foot .item{
        margin-bottom: .12rem;
    }
    .list-foot .item:last-child{
        margin-bottom: 0;
    }
    .list-foot .item .red{
        color: #2CAADE!important;
    }
    .status{
        position: absolute;
        right: 0;
        top: 0;
        padding: .12rem .22rem;
        color: #fff;
        font-size: .24rem;        
        background: rgba(44, 170, 222,.2);
        border-radius: 0px 10px 0px 10px;
    }
    .status.active{        
        background: rgba(157, 157, 157,.2);
    }
    .status .icon{
        margin-left: .1rem;
        width: .28rem;
        height: .28rem;
    }
    .alert-wrap{
        position: absolute;
        left: .72rem;
        right: .72rem;
        top: 50%;
        z-index: 1000;
        width: auto;        
        background: rgba(26, 36, 64,.8);
        border-radius: .2rem;
        transform: translateY(-50%);
    }
    .alert-wrap .alert-head,.alert-wrap2 .alert-head{
        position: relative;
        padding: .28rem 0 .5rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap .alert-head .icon,.alert-wrap2 .alert-head .icon{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .3rem;
        height: .3rem;
    }
    .alert-wrap .cont{
        max-height: 6rem;
        padding: 0 .4rem .72rem .4rem;
        color: #fff;
        font-size: .28rem;
        overflow: auto;
    }
    .alert-wrap2{
        position: absolute;
        left: .72rem;
        right: .72rem;
        top: 1.52rem;
        z-index: 1000;
        width: auto;        
        background: #1A2440;
        border-radius: .2rem;        
    }
</style>


// WEBPACK FOOTER //
// src/pages/myOrderDetail.vue